// ----------------------------------------------------------------------

export const JWT_STORAGE_KEY = 'access';
export const REFRESH_STORAGE_KEY = 'refresh';
export const USER_STORAGE_KEY = 'auth-user';
